module.exports = __webpack_public_path__ + "static/media/modify.8bb5620d.svg";